<template>
  <div class="tw-flex tw-flex-col-reverse lg:tw-flex-row tw-gap-4">
    <div class="tw-w-full lg:tw-w-1/4 xl:tw-w-1/5">
      <RelatedGames :game="game"></RelatedGames>
    </div>
    <div class="tw-flex-1">
      <PlayFrame @selectedGame="game = $event"></PlayFrame>
    </div>
  </div>
</template>
<script>
import PlayFrame from "../../components/Play/PlayFrame.vue";
import RelatedGames from "../../components/Play/RelatedGames.vue";

export default {
  components: { PlayFrame, RelatedGames },
  data() {
    return {
      game: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
};
</script>
